"use client";

import React from "react";
import { CircleCheck, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = ["Professional Excellence: Our team is expertly trained to deliver meticulous results for every Vero Beach home.", "Eco-Friendly Approach: We use safe, non-toxic products that protect your family, pets, and the coastal environment.", "Local Commitment: Proudly serving our neighbors with the reliability and care that only a local business can provide.", "Tailored Solutions: Whether it's a beachside rental or a family home, we customize our cleaning to your needs."];
export default function WaterPurificationAtHome() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224114" id="the-coastal-difference" className="bg-background bg-gradient-to-br from-background to-secondary/40 py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          
          {}
          <div ref={contentRef} className={`flex flex-col space-y-8 transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="space-y-4">
              <h2 className="font-default text-3xl md:text-4xl lg:text-5xl font-bold text-foreground leading-tight tracking-tight">
                The Coastal Difference
              </h2>
              <p className="text-lg text-muted-foreground font-default max-w-xl leading-relaxed">
                Experience a higher standard of clean with our dedicated local team. We combine professional expertise with a neighborly touch to keep your Vero Beach home or business sparkling like the Florida coastline, ensuring a fresh and healthy space for you to enjoy.
              </p>
            </div>

            <ul className="space-y-5">
              {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                  <div className="mt-1 shrink-0">
                    <CircleCheck className="size-6 text-chart-2" strokeWidth={2.5} />
                  </div>
                  <span className="text-foreground font-medium text-lg font-default leading-snug">
                    {benefit}
                  </span>
                </li>)}
            </ul>

            <div className="pt-4">
              <Button asChild size="lg" className="group bg-primary hover:bg-primary/90 text-primary-foreground rounded-full px-8 shadow-md">
                <Link to="#">
                  Book Your Clean
                  <ArrowRight className="ml-2 size-4 transition-transform group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`relative transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative rounded-3xl overflow-hidden border border-border shadow-xl bg-white">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1635001/img/cleaner_portrait.png" alt="Professional cleaner from Coastal Cleaning of Vero Beach" className="w-full h-auto object-cover aspect-[4/3] hover:scale-105 transition-transform duration-700 ease-in-out" />
              {}
              <div className="absolute inset-0 bg-gradient-to-tr from-white/10 to-transparent pointer-events-none backdrop-blur-[1px]" />
            </div>
            
            {}
            <div className="absolute -z-10 -bottom-8 -right-8 w-64 h-64 bg-secondary rounded-full blur-3xl opacity-60" />
          </div>

        </div>
      </div>
    </section>;
}